module.exports = __webpack_public_path__ + "img/DOTA-BT1718.885f412d.png";